import Vue from 'vue'
import Router from 'vue-router'
import InvoiceSearch from '@/page/InvoiceSearch'
import InvoiceList from '@/page/InvoiceList'
import InvoiceAddSearch from '@/page/InvoiceAddSearch'
import InvoiceHelp from '@/page/InvoiceHelp'
import InvoiceAdd from '@/page/InvoiceAdd'
import InvoiceDetail from '@/page/InvoiceDetail'
import { Checkbox, CheckboxGroup, Cell, CellGroup } from 'vant'

Vue.use(Cell).use(CellGroup)
Vue.use(Router)
Vue.use(Checkbox).use(CheckboxGroup)

export default new Router({
  routes: [
    {
      path: '/invoiceSearch',
      name: 'invoiceSearch',
      component: InvoiceSearch,
      meta: {
        index: 1,
        title: '发票查询'
      }
    },
    {
      path: '/',
      name: 'invoiceAddSearch',
      component: InvoiceAddSearch,
      meta: {
        index: 2,
        title: '发票开具'
      }
    },
    {
      path: '/invoiceHelp',
      name: 'invoiceHelp',
      component: InvoiceHelp,
      meta: {
        index: 3,
        title: '发票帮助'
      }
    },
    {
      path: '/invoiceList',
      name: 'invoiceList',
      component: InvoiceList,
      meta: {
        index: 4,
        title: '查询结果'
      }
    },
    {
      path: '/invoiceAdd',
      name: 'invoiceAdd',
      component: InvoiceAdd,
      meta: {
        index: 4,
        title: '开具电子发票'
      }
    },
    {
      path: '/invoiceDetail/:id',
      name: 'invoiceDetail',
      component: InvoiceDetail,
      meta: {
        index: 5,
        title: '电子发票详情'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js